import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMain,[_c(VContainer,{attrs:{"id":"add-user-container","fluid":"","tag":"section"}},[_c('base-material-card',{ref:"form",staticClass:"px-5 py-3",attrs:{"icon":"mdi-logout"}},[_c(VAlert,{attrs:{"color":"success","dark":"","outlined":""}},[_c('p',[_vm._v("You have logged out of your account successfully.")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }